export const environment = {
  production: true,
  apiUrl: "https://api.alutracksuite.in/api",
  name: "prod",
};